<template>
    <div class="index">
        <div class="index-item" >
            <div class="card" v-for="(item, index) of shoplist" @click="toDetails(item)" :key="index" v-if="shoplist.length>0">
                <div class="card-left">
                    <img v-if="item.shop_img" :src="item.shop_img" alt="">
                    <img v-else src="../../assets/icon/home/icon_fjmd.png" />
                    <div class="card-content">
                        <div class="card-content-name">{{ item.name }}</div>
                        <div class="card-content-address">{{ item.address }}</div>
                    </div>
                </div>
                <div class="card-right"><img src="../../assets/icon/right.png" /></div>
            </div>
            <div v-if="shoplist.length==0" class="index-empty">
                <img src="../../assets/icon/img_zanwu.png" alt="">
            </div>
        </div>
        <div class="index-logo">
            <img src="../../assets/img/logo.png">
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import qs from 'qs'
export default {
    name: 'ShopIndex',
    data() {
        return {
            shoplist: [],
        }
    },
    computed: {
        ...mapGetters(['location'])
    },
    mounted() {
        setTimeout(() => {
            this.getShoplist()
        }, 500)
    },
    methods: {
        toDetails(item) {
            this.$router.push({ name: 'ShopDetails', params: { ...item } })
        },
        getShoplist() {
            let that = this;
            const url = `/shop/near/?latitude=${this.location.latitude}&longitude=${this.location.longitude}`
            this.axios.get(url).then(function (res) {
                if (res.data) {
                    that.shoplist = res.data
                }
            }).catch(function (error) {
                console.log(error)
            })
        },

    }
}

</script>

<style lang="scss" scoped>
.index {
    background: #F6F8FA;
    height: 233px;
    background: linear-gradient(180deg, #FFE09A 0%, #F6F8FA 100%);

    &-item {
        position: relative;
        display: flex;
        flex-direction: column;
        margin-left: 16px;
        margin-right: 16px;
        // overflow-y: scroll;
        // height: 100vh;

    }
    &-empty{
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            margin-top: 60%;
            width: 200px;
            height: 200px;
        }
    }
    .card {
        margin-top: 10px;
        display: flex;
        align-items: center;
        background: #FFFFFF;
        border-radius: 16px;
        padding: 15px;
        justify-content: space-between;

        &-left {
            display: flex;
            align-items: center;

            img {
                width: 60px;
                height: 60px;
                margin-right: 15px;
                flex-shrink: 0;
                border-radius: 5px;
            }
        }

        &-content {
            height: 100%;

            // position: relative;
            &-name {
                flex: 1;
                margin-bottom: 15px;
                flex-shrink: 0;
                font-weight: 500;
                font-size: 14px;
                color: #111827;
            }

            &-address {
                flex: 1;
                flex-shrink: 0;
                font-weight: 400;
                font-size: 14px;
                color: #718096;
                flex-wrap: wrap;

            }
        }

        &-right {

            img {
                flex-shrink: 0;
                width: 20px;
                height: 20px;

            }
        }
    }



    &-logo {
        // position: absolute;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 30px;

        img {
            padding-top: 20px;
            padding-bottom: 50px;
            width: 120px;
            height: 30px;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/pages/shop/index.vue